export default from './Modal';


// WEBPACK FOOTER //
// ./js/components/Modal/index.js